// extracted by mini-css-extract-plugin
export var alpha = "_8r-4";
export var alphaInputContainer = "_8r-f";
export var badge = "_8r-b";
export var brandKitGrid = "_8r-h";
export var brandKitItem = "_8r-i";
export var brandKitSwatch = "_8r-j";
export var controls = "_8r-5";
export var formatDropdown = "_8r-d";
export var formatSelector = "_8r-c";
export var hex = "_8r-6";
export var hexInput = "_8r-e";
export var hue = "_8r-3";
export var hueAndAlphaPointer = "_8r-a";
export var percentageLabel = "_8r-g";
export var picker = "_8r-0";
export var rgba = "_8r-8";
export var rgbaSection = "_8r-7";
export var saturation = "_8r-1";
export var saturationPointer = "_8r-9";
export var sliders = "_8r-2";